(() => {
  if (customElements.get('customer-review-slider')) return;

  class CustomerReviewSlider extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._slides = Array.from(this.querySelectorAll('[data-review-slide]'));
      this._track = this.querySelector('[data-review-track]');
      this._dots = Array.from(this.querySelectorAll('[data-review-go]'));
      this._index = 0;
      this._interval = Math.max(2000, Number(this.dataset.interval) || 5000);
      this._remaining = this._interval;
      this._paused = false;

      if (!this._track || this._slides.length < 2) return;

      this._handleClick = (event) => {
        const dot = event.target.closest('[data-review-go]');
        if (dot) this._show(Number(dot.dataset.reviewGo));
      };
      this._pause = () => {
        if (this._paused) return;
        this._paused = true;
        this.classList.add('is-paused');
        this._remaining = Math.max(0, this._deadline - Date.now());
        window.clearTimeout(this._timer);
      };
      this._resume = () => {
        if (!this._paused) return;
        this._paused = false;
        this.classList.remove('is-paused');
        this._schedule(this._remaining || this._interval);
      };
      this._handleVisibility = () => {
        if (document.hidden) this._pause();
        else if (this._paused) this._resume();
        else this._schedule(this._remaining || this._interval);
      };

      this.addEventListener('click', this._handleClick);
      this.addEventListener('mouseenter', this._pause);
      this.addEventListener('mouseleave', this._resume);
      this.addEventListener('focusin', this._pause);
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this._resume();
      });
      document.addEventListener('visibilitychange', this._handleVisibility);
      this._show(0);
    }

    disconnectedCallback() {
      window.clearTimeout(this._timer);
      if (this._handleVisibility) document.removeEventListener('visibilitychange', this._handleVisibility);
    }

    _show(nextIndex) {
      window.clearTimeout(this._timer);
      this._index = (nextIndex + this._slides.length) % this._slides.length;
      this._track.style.transform = `translateX(-${this._index * 100}%)`;
      this._slides.forEach((slide, index) => {
        const active = index === this._index;
        slide.classList.remove('is-active');
        slide.setAttribute('aria-hidden', String(!active));
        slide.toggleAttribute('inert', !active);
        if (active) {
          void slide.offsetWidth;
          slide.classList.add('is-active');
        }
      });
      this._dots.forEach((dot, index) => {
        const active = index === this._index;
        dot.setAttribute('aria-current', String(active));
        dot.tabIndex = active ? 0 : -1;
      });
      this._remaining = this._interval;
      this._schedule();
    }

    _schedule(delay = this._interval) {
      window.clearTimeout(this._timer);
      if (this._paused || window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.hidden) return;
      this._deadline = Date.now() + delay;
      this._timer = window.setTimeout(() => this._show(this._index + 1), delay);
    }
  }

  customElements.define('customer-review-slider', CustomerReviewSlider);
})();
